"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardRowComponent_vue_1 = require("@/client/components/card/CardRowComponent.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardRowData',
    props: {
        rowData: {
            type: Array,
            required: true,
        },
    },
    components: {
        CardRowComponent: CardRowComponent_vue_1.default,
    },
});
